export default "__VITE_ASSET__DDEjcg69__"